import { slice } from './slice';

const { reducer } = slice;

export * from './actions';
export * as appVersionsSelectors from './selectors';

export default reducer;
